import { inject } from '@angular/core';
import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { from, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { DeviceIdService } from '../services/device-id.service';

export const deviceIdInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
  if (!shouldAttachDeviceId(req)) {
    return next(req);
  }
  const deviceIdService = inject(DeviceIdService);
  return from(deviceIdService.getDeviceId()).pipe(
    switchMap(deviceId => {
      const cloned = req.clone({
        setHeaders: { 'x-device-id': deviceId }
      });
      return next(cloned);
    })
  );
};

function shouldAttachDeviceId(req: HttpRequest<any>): boolean {
  return req.method === 'POST' && /\/api\/v1\/project\b/.test(req.url);
}
